import React from 'react';

import { Newsletter } from '@utils/backend-api/newsletters';

import NewsletterAction from './NewsletterActions';
import NewsletterDetails from './NewsletterDetails';
import NewsletterImage from './NewsletterImage';

interface NewsletterCardProps {
  newsletter: Newsletter;
  updateNewsletterSubscription: (id: number, subscribed: boolean) => void;
}

const NewsletterCard = ({
  newsletter: {
    accessLevel,
    afterSignUpUrl,
    author,
    cardImageUrl,
    currentUserSubscribed,
    description,
    frequency,
    hasPublishedArticles,
    id,
    isProOnly,
    isSubscriberOnly,
    name,
    offerCode,
    previewDays,
    readLatestPath,
  },
  updateNewsletterSubscription,
}: NewsletterCardProps) => {
  return (
    <div
      data-testid={id}
      className="newsletter flex max-w-[299px] flex-col justify-between bg-grayscale-beige/50"
    >
      <div className="px-20 py-20">
        <NewsletterDetails
          frequency={frequency}
          author={author}
          description={description}
          name={name}
        />
        <NewsletterAction
          id={id}
          currentUserSubscribed={currentUserSubscribed}
          isSubscriberOnly={isSubscriberOnly}
          accessLevel={accessLevel}
          name={name}
          updateNewsletterSubscription={updateNewsletterSubscription}
          description={description}
          offers={{
            subscribe: offerCode,
          }}
          isPro={isProOnly}
          afterSignUpUrl={afterSignUpUrl}
          hasPublishedArticles={hasPublishedArticles}
          readLatestPath={readLatestPath}
        />
      </div>
      <NewsletterImage
        cardImageUrl={cardImageUrl}
        previewDays={previewDays}
        isProSubscribeOnly={isProOnly}
        isSubscribeOnly={isSubscriberOnly}
      />
    </div>
  );
};

export default NewsletterCard;
